import React from 'react';
import  SlideBabyweek from '../swiper/sliderbabyweek' 

export default function ({ babyThisWeek, eleRef }) {
    // //console.log("babyThisWeek",babyThisWeek)
   
    return (        
        
            <section className="main-view-baby-week feed_desktop_border21 babyThisWeek">
                <div className="baby-week-header"> 
                    <h2>  {babyThisWeek.title?babyThisWeek.title:''} </h2>
                </div>
                <div className='babyWeekContainer'>
                    <SlideBabyweek page={"dr-carousel-unit"} data={babyThisWeek.data} />
                </div>
                    {/* <div className="baby-week-social-view"> 
                        <div className="post-options">
                          <div className="icon left devMemoLike font-sizeview" data-icon-font="$"> <span className="icons-text R13_61"> 124</span> </div>
                          <div className="icon left" data-icon-font=""> <span className="icons-text R13_61"> 286 </span> </div>
                        </div> 
                        <div className="m-abuse-main right">
                            <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                            <div className="icon left icon3dot whatsapp-icons" data-icon-font=""> <span className="icons-text cursor-pointer R13_61"> Share </span></div>
                        </div>
                    </div> */}
            </section>     

    )
}
